import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'

import { Product } from '@/api/_schemas/management'
import { ComboProduct } from '@/app/panel/management/price-list/_schemas/update-product-types'

type UpdateProductContextValues = {
  priceListId: number
  product: Product
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  comboProducts: ComboProduct[]
  setComboProducts: React.Dispatch<React.SetStateAction<ComboProduct[]>>
}

type UpdateProductContextProviderProps = PropsWithChildren & {
  value: Pick<UpdateProductContextValues, 'priceListId' | 'product'>
}

const UpdateProductContext = createContext<UpdateProductContextValues>(
  {} as UpdateProductContextValues,
)

const UpdateProductContextProvider = ({
  children,
  value,
}: UpdateProductContextProviderProps) => {
  const [open, setOpen] = useState(false)

  const [comboProducts, setComboProducts] = useState<ComboProduct[]>(
    value.product.produto_combo_list ?? [],
  )

  useEffect(() => {
    setComboProducts(value.product.produto_combo_list ?? [])
  }, [value.product.produto_combo_list])

  return (
    <UpdateProductContext.Provider
      value={{ ...value, open, setOpen, comboProducts, setComboProducts }}
    >
      {children}
    </UpdateProductContext.Provider>
  )
}

function useUpdateProductContext() {
  return useContext(UpdateProductContext)
}

export { UpdateProductContextProvider, useUpdateProductContext }
